(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3130],{

/***/ 20976:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bring-your-own-team",
      function () {
        return __webpack_require__(93654);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ bring_your_own_team; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.tsx
var Faqs = __webpack_require__(29372);
// EXTERNAL MODULE: ./components/marketingSite/shared/Feature.tsx + 1 modules
var Feature = __webpack_require__(60099);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamCommitment.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n  text-align: center;\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-8769b142-0"
})(_templateObject(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamCommitment.tsx








var BringYourOwnTeamCommitment = function() {
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                editorial: true,
                children: t("commitment.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "bring-your-own-team",
                    i18nKey: "commitment.desc",
                    components: {
                        ethic: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/compromiso-etico-manfred")
                        })
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var bringYourOwnTeam_BringYourOwnTeamCommitment = (BringYourOwnTeamCommitment);

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamComponent.styled.ts

function BringYourOwnTeamComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -",
        ";\n  overflow-x: hidden;\n"
    ]);
    BringYourOwnTeamComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var BringYourOwnTeamComponent_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cabd09cc-0"
})(BringYourOwnTeamComponent_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cabd09cc-1"
})(_templateObject1(), (0,theme/* color */.$_)("white"));

// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamHero.styled.tsx

function BringYourOwnTeamHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat, no-repeat;\n  background-position: center bottom, bottom;\n  padding: ",
        " ",
        " ",
        ";\n  position: relative;\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    background-position: right calc(50% - 29.4rem) bottom -3.3rem, bottom;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    BringYourOwnTeamHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BringYourOwnTeamHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: center top;\n"
    ]);
    BringYourOwnTeamHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n\n  &:hover {\n    animation: vibrate 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite;\n  }\n\n  @keyframes vibrate {\n    0% {\n      transform: translate(0);\n    }\n    10% {\n      transform: translate(-2px, -2px);\n    }\n    20% {\n      transform: translate(2px, -2px);\n    }\n    30% {\n      transform: translate(-2px, 2px);\n    }\n    40% {\n      transform: translate(2px, 2px);\n    }\n    50% {\n      transform: translate(-2px, -2px);\n    }\n    60% {\n      transform: translate(2px, -2px);\n    }\n    70% {\n      transform: translate(-2px, 2px);\n    }\n    80% {\n      transform: translate(-2px, -2px);\n    }\n    90% {\n      transform: translate(2px, -2px);\n    }\n    100% {\n      transform: translate(0);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  position: absolute;\n  bottom: ",
        ";\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: column;\n  align-items: center;\n  margin-top: auto;\n  padding-top: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  z-index: 1;\n\n  &:hover {\n    color: ",
        ";\n    opacity: 0.9;\n  }\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 2.5rem;\n  width: 1.5rem;\n  margin-bottom: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(",
        " - ",
        " / 2 - 2px);\n  left: calc(50% - ",
        " / 2);\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  animation: ball 3.5s ease-in-out infinite;\n\n  @keyframes ball {\n    0% {\n      height: ",
        ";\n      top: calc(",
        " - ",
        " / 2 - 2px);\n    }\n    30% {\n      height: ",
        ";\n      top: calc(",
        " - ",
        " / 2 - 2px);\n      background-color: ",
        ";\n    }\n    50% {\n      height: ",
        ";\n      top: ",
        ";\n      background-color: ",
        ";\n    }\n    75% {\n      height: ",
        ";\n      top: ",
        ";\n    }\n    100% {\n      top: calc(",
        " - ",
        " / 2 - 2px);\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n\n  strong {\n    font-weight: ",
        ";\n    opacity: 0;\n    animation: appear 3.5s ease-in-out infinite;\n\n    @keyframes appear {\n      40% {\n        opacity: 0;\n      }\n      50% {\n        opacity: 1;\n      }\n      75% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-0"
})(BringYourOwnTeamHero_styled_templateObject(), function() {
    return " url('".concat((0,paths/* getPublicPath */.A)("/images/bringYourOwnTeam/space-ship-tail.svg"), "'), linear-gradient(\n126deg,#147092,#147092 10%,#0da1a4 50%,#28cebc 100%,#28cebc 0)");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl8"), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl7"));
var StyledHeroStars = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-1"
})(BringYourOwnTeamHero_styled_templateObject1(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/bringYourOwnTeam/estrellas.svg"), "')");
});
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-2"
})(_templateObject2(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"));
var StyledHeroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-3"
})(_templateObject3(), (0,theme/* container */.nC)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-a3e26651-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("lg"));
var StyledHeroActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("xl3"));
var StyledHeroImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-6"
})(_templateObject6());
var StyledHeroScroll = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a3e26651-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* container */.nC)("xl"));
var StyledHeroScrollMouse = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("xs"), (0,theme/* radius */.q0)("full"));
var StyledHeroScrollMouseBall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("active"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"));
var StyledHeroScrollText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3e26651-10"
})(_templateObject10(), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamHero.tsx








var BringYourOwnTeamHero = function(param) {
    var teams = param.teams;
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroStars, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                                children: t("hero.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("hero.desc")
                            }),
                            (teams === null || teams === void 0 ? void 0 : teams.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroActions, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                    href: "#teams",
                                    variant: "primary",
                                    sizes: "md",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("hero.CTA")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/bringYourOwnTeam/space-ship.svg"),
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroScroll, {
                href: "#teams",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroScrollMouse, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroScrollMouseBall, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroScrollText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "bring-your-own-team",
                            i18nKey: "hero.scrollText"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bringYourOwnTeam_BringYourOwnTeamHero = (BringYourOwnTeamHero);

// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamHow.styled.tsx

function BringYourOwnTeamHow_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        " ",
        ";\n"
    ]);
    BringYourOwnTeamHow_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BringYourOwnTeamHow_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    BringYourOwnTeamHow_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BringYourOwnTeamHow_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: ",
        " auto;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: stretch;\n  }\n"
    ]);
    BringYourOwnTeamHow_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BringYourOwnTeamHow_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 25rem;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  position: relative;\n  font-size: ",
        ";\n  line-height: 1.42;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    width: 20%;\n    padding-left: ",
        ";\n    padding-top: ",
        ";\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: -",
        ";\n    left: 0;\n    right: 0;\n    height: ",
        ";\n    clip-path: polygon(0 0, 100% 0, 50% 100%);\n    z-index: 1;\n\n    @media (min-width: ",
        ") {\n      top: 0;\n      bottom: 0;\n      left: unset;\n      right: -",
        ";\n      height: unset;\n      width: ",
        ";\n      clip-path: polygon(0 0, 100% 50%, 0 100%);\n    }\n  }\n\n  &:first-of-type {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(2) {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(3) {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(4) {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:last-of-type {\n    background-color: ",
        ";\n\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &:nth-of-type(n + 3) {\n    color: ",
        ";\n  }\n"
    ]);
    BringYourOwnTeamHow_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BringYourOwnTeamHow_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n\n  @media (min-width: ",
        ") {\n    min-height: 2em;\n  }\n"
    ]);
    BringYourOwnTeamHow_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BringYourOwnTeamHow_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    BringYourOwnTeamHow_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var BringYourOwnTeamHow_styled_StyledContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-dd8e6256-0"
})(BringYourOwnTeamHow_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd8e6256-1"
})(BringYourOwnTeamHow_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledSteps = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd8e6256-2"
})(BringYourOwnTeamHow_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("lg"));
var StyledStepsItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd8e6256-3"
})(BringYourOwnTeamHow_styled_templateObject3(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("navy_100"), (0,theme/* color */.$_)("navy_100"), (0,theme/* color */.$_)("navy_200"), (0,theme/* color */.$_)("navy_200"), (0,theme/* color */.$_)("navy_300"), (0,theme/* color */.$_)("navy_300"), (0,theme/* color */.$_)("navy_500"), (0,theme/* color */.$_)("navy_500"), (0,theme/* color */.$_)("navy_600"), (0,theme/* color */.$_)("navy_600"), (0,theme/* color */.$_)("white"));
var StyledStepsTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-dd8e6256-4"
})(BringYourOwnTeamHow_styled_templateObject4(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* screen */.sp)("lg"));
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd8e6256-5"
})(BringYourOwnTeamHow_styled_templateObject5(), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamHow.tsx







var BringYourOwnTeamHow = function() {
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    var steps = [
        t("how.steps.step1"),
        t("how.steps.step2"),
        t("how.steps.step3"),
        t("how.steps.step4"),
        t("how.steps.step5")
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BringYourOwnTeamHow_styled_StyledContainer, {
        id: "teams",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                        editorial: true,
                        children: t("how.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("how.desc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSteps, {
                children: steps.map(function(s, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepsItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepsTitle, {
                            children: s
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActions, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                        variant: "brandTalent",
                        href: "https://getmanfred.typeform.com/to/AEJG1scy",
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faPlusCircle */.KtF
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("how.teamCTA")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                        href: "#teams",
                        variant: "brandCompany",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faBriefcase */.HXv
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("how.companyCTA")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bringYourOwnTeam_BringYourOwnTeamHow = (BringYourOwnTeamHow);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(97000);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamCard.styled.tsx

function BringYourOwnTeamCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        " ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        " ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  text-align: center;\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n\n  img {\n    width: 2.15rem;\n    height: auto;\n    filter: grayscale(100%);\n  }\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  &.extra {\n    display: none;\n\n    &.show {\n      display: flex;\n    }\n  }\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n\n  img {\n    flex-shrink: 0;\n    width: ",
        ";\n    height: ",
        ";\n    display: block;\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        " ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function BringYourOwnTeamCard_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border: 0;\n  color: ",
        ";\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  display: inline-flex;\n  align-self: center;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n  position: relative;\n  transition: 0.3s;\n\n  &.hide {\n    display: none;\n  }\n\n  &::before,\n  &::after {\n    content: '';\n    width: ",
        ";\n    height: 1px;\n    background-color: ",
        ";\n  }\n\n  &:hover {\n    color: ",
        ";\n    &::before,\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    BringYourOwnTeamCard_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-0"
})(BringYourOwnTeamCard_styled_templateObject(), (0,theme/* color */.$_)("sand_100"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-1"
})(BringYourOwnTeamCard_styled_templateObject1(), (0,theme/* color */.$_)("navy_400"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-2"
})(BringYourOwnTeamCard_styled_templateObject2(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledTechs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-3"
})(BringYourOwnTeamCard_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var StyledTechItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-4"
})(BringYourOwnTeamCard_styled_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-5"
})(BringYourOwnTeamCard_styled_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledInfoItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-6"
})(BringYourOwnTeamCard_styled_templateObject6(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledMembers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-7"
})(BringYourOwnTeamCard_styled_templateObject7(), (0,theme/* spacing */.W0)("lg"));
var StyledMemberItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-8"
})(BringYourOwnTeamCard_styled_templateObject8(), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"));
var StyledMemberExperience = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6925d40b-9"
})(BringYourOwnTeamCard_styled_templateObject9(), (0,theme/* color */.$_)("midnight_150"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("xs"));
var StyledShowMore = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-6925d40b-10"
})(BringYourOwnTeamCard_styled_templateObject10(), (0,theme/* color */.$_)("navy_400"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("navy_400"), (0,theme/* color */.$_)("navy_600"), (0,theme/* color */.$_)("navy_600"));

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamCard.tsx








var BringYourOwnTeamCard = function(param) {
    var team = param.team;
    var showExtraMembers = function showExtraMembers() {
        setShowMembers(true);
    };
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    var ref = (0,react.useState)(false), showMembers = ref[0], setShowMembers = ref[1];
    var roleIcons = {
        backend: (0,paths/* getPublicPath */.A)("/images/experience/backend.png"),
        data: (0,paths/* getPublicPath */.A)("/images/experience/data.png"),
        design: (0,paths/* getPublicPath */.A)("/images/experience/design.png"),
        frontend: (0,paths/* getPublicPath */.A)("/images/experience/frontend.png"),
        leadership: (0,paths/* getPublicPath */.A)("/images/experience/leadership.png"),
        misc: (0,paths/* getPublicPath */.A)("/images/experience/misc.png"),
        mobile: (0,paths/* getPublicPath */.A)("/images/experience/mobile.png"),
        productmgmt: (0,paths/* getPublicPath */.A)("/images/experience/productmgmt.png"),
        systems: (0,paths/* getPublicPath */.A)("/images/experience/systems.png")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBadge, {
                children: [
                    t("teams.cards.cardTitle"),
                    " ",
                    team.members.length
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: t("teams.cards.stackTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechs, {
                        children: team.stack.map(function(s, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTechItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: s.icon,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            s.tech,
                                            " "
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfoItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                children: t("teams.cards.salaryTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: team.salary
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfoItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                children: t("teams.cards.ubicationTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: team.location
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMembers, {
                children: team.members.slice(0, 5).map(function(m, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMemberItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: roleIcons[m.roleType] || roleIcons["misc"],
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: m.role
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMemberExperience, {
                                        children: m.experience
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            }),
            team.members.length > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShowMore, {
                onClick: showExtraMembers,
                className: "".concat(showMembers ? "hide" : ""),
                children: t("teams.cards.showMore")
            }),
            showMembers && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMembers, {
                children: team.members.slice(5, team.members.length).map(function(m, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMemberItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/experience/" + m.roleType + ".png"),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: m.role
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMemberExperience, {
                                        children: m.experience
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                variant: "primary",
                href: "https://getmanfred.typeform.com/to/eTkbS7x5/" + team.typeformCode,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("teams.cards.CTA")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bringYourOwnTeam_BringYourOwnTeamCard = (BringYourOwnTeamCard);

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamTeams.styled.tsx

function BringYourOwnTeamTeams_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    BringYourOwnTeamTeams_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BringYourOwnTeamTeams_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  .masonry-grid {\n    display: flex;\n    margin-left: -",
        "; /* gutter size offset */\n    width: auto;\n  }\n  .masonry-column {\n    padding-left: ",
        "; /* gutter size */\n    background-clip: padding-box;\n\n    &:empty {\n      display: none;\n    }\n\n    > div {\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    BringYourOwnTeamTeams_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var BringYourOwnTeamTeams_styled_StyledContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-258caf1d-0"
})(BringYourOwnTeamTeams_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading2 */.XJ);
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-258caf1d-1"
})(BringYourOwnTeamTeams_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamTeams.tsx









var BringYourOwnTeamTeams = function(param) {
    var techs = param.techs, teams = param.teams;
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    var breakpointColumnsObj = {
        default: 3,
        1000: 2,
        630: 1
    };
    var isTech = function(item) {
        return !!item;
    };
    var teamsTechs = teams.map(function(team) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, team), {
            stack: team.stack.map(function(techId) {
                var ref;
                var tech = techs.find(function(tech) {
                    return tech.id === techId;
                });
                if (!tech) {
                    return null;
                }
                return {
                    tech: tech.name,
                    icon: ((ref = tech.icon) === null || ref === void 0 ? void 0 : ref.url) || config/* config.defaultTechIcon */.v.defaultTechIcon
                };
            }).filter(isTech)
        });
    });
    if (teamsTechs.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BringYourOwnTeamTeams_styled_StyledContainer, {
        id: "teams",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                editorial: true,
                children: t("teams.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                    breakpointCols: breakpointColumnsObj,
                    className: "masonry-grid",
                    columnClassName: "masonry-column",
                    children: teamsTechs.map(function(t, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(bringYourOwnTeam_BringYourOwnTeamCard, {
                            team: t
                        }, i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var bringYourOwnTeam_BringYourOwnTeamTeams = (BringYourOwnTeamTeams);

;// CONCATENATED MODULE: ./components/marketingSite/bringYourOwnTeam/BringYourOwnTeamComponent.tsx














var BringYourOwnTeamComponent = function(param) {
    var techs = param.techs, teams = param.teams;
    //const { locale } = useRouter();
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    var desc = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
        ns: "bring-your-own-team",
        i18nKey: "faqs.desc",
        components: {
            mail: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "mailto:team@getmanfred.com"
            })
        }
    });
    var faqs = [
        {
            question: t("faqs.faq1.question"),
            answer: t("faqs.faq1.answer")
        },
        {
            question: t("faqs.faq2.question"),
            answer: t("faqs.faq2.answer")
        },
        {
            question: t("faqs.faq3.question"),
            answer: t("faqs.faq3.answer")
        },
        {
            question: t("faqs.faq4.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "bring-your-own-team",
                i18nKey: "faqs.faq4.answer"
            }),
            renderComponent: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        topBarTransparent: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BringYourOwnTeamComponent_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bringYourOwnTeam_BringYourOwnTeamHero, {
                    teams: teams
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature/* default */.Z, {
                    title: t("feature.title"),
                    text: t("feature.desc"),
                    action: t("feature.CTA"),
                    actionHref: "https://getmanfred.typeform.com/to/AEJG1scy",
                    image: "bring-your-own-team-feature.svg",
                    btnVariant: "primary",
                    actionIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bringYourOwnTeam_BringYourOwnTeamTeams, {
                            techs: techs,
                            teams: teams
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bringYourOwnTeam_BringYourOwnTeamHow, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bringYourOwnTeam_BringYourOwnTeamCommitment, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                    faqs: faqs,
                    title: t("faqs.title"),
                    desc: desc
                })
            ]
        })
    });
};
/* harmony default export */ var bringYourOwnTeam_BringYourOwnTeamComponent = (BringYourOwnTeamComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/bring-your-own-team.tsx







var BringYourOwnTeamPage = function(param) {
    var techs = param.techs, teams = param.teams, baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("bring-your-own-team").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("page_title"),
                url: app_urls/* APP_URLS.bringYourOwnTeam */.uu.bringYourOwnTeam,
                desc: t("page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_bring_your_own_team.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bringYourOwnTeam_BringYourOwnTeamComponent, {
                techs: techs,
                teams: teams
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var bring_your_own_team = (BringYourOwnTeamPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,1122,625,4882,7265,27,9774,2888,179], function() { return __webpack_exec__(20976); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);